/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductionOrderPredecessorInfo } from '../../models/production-order-predecessor-info';

export interface GetProductionOrderPredecessorInfo$Params {
  productionOrderId: number;
}

export function getProductionOrderPredecessorInfo(http: HttpClient, rootUrl: string, params: GetProductionOrderPredecessorInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductionOrderPredecessorInfo>> {
  const rb = new RequestBuilder(rootUrl, getProductionOrderPredecessorInfo.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductionOrderPredecessorInfo>;
    })
  );
}

getProductionOrderPredecessorInfo.PATH = '/api/v1/ProductionOrder/{productionOrderId}/PredecessorInfo';
